import React from 'react';
import roles from '@utils/rolesConstants';
import Inventory from '@pages/Assets/Inventory';
import ActionsQueue from '@pages/Operational/ActionsQueue';
import Reports from '@pages/Support/Reports';
import {
  AlertOutlined,
  ApartmentOutlined,
  AuditOutlined,
  BarChartOutlined,
  BellOutlined,
  CarryOutOutlined,
  ContainerOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FileImageOutlined,
  FormatPainterOutlined,
  HistoryOutlined,
  LaptopOutlined,
  LineChartOutlined,
  MergeCellsOutlined,
  NodeExpandOutlined,
  PieChartOutlined,
  SettingOutlined,
  SnippetsOutlined,
  SwapOutlined,
  TeamOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  WarningOutlined,
  WifiOutlined,
} from '@ant-design/icons';
import APNs from '@pages/Access/Apns';
import Customers from '@pages/Access/Customers';
import UserGroups from '@pages/Access/Groups';
import MyUser from '@pages/Access/MyUser';
import UserAccounts from '@pages/Access/Users';
import Groupings from '@pages/Administrative/Groupings';
import Personalization from '@pages/Administrative/Personalization';
import Alerts from '@pages/Alerts';
import AlertsEvents from '@pages/Alerts/Events';
import ConnectedDevices from '@pages/Assets/ConnectedDevices';
import Maps from '@pages/Assets/Maps';
import Sessions from '@pages/Assets/Sessions';
import Transactions from '@pages/Assets/Transactions';
import TransactionsAcquiring from '@pages/Assets/TransactionsAcquiring';
import ContractsMoT from '@pages/Financial/ContractsMoT';
import DetailedContract from '@pages/Financial/ContractsMoT/DetailedContract';
import CustomersContracts from '@pages/Financial/CustomersContracts';
import DetailedContractCustomer from '@pages/Financial/CustomersContracts/DetailedContractCustomer';
import Invoices from '@pages/Financial/Invoices';
import InvoicesMultiConnectDetailed from '@pages/Financial/Invoices/InvoiceDetailed';
import InvoicesMot from '@pages/Financial/InvoicesMot';
import InvoiceActions from '@pages/Financial/InvoicesMot/InvoiceActions';
import InvoiceActionDetails from '@pages/Financial/InvoicesMot/InvoiceActions/InvoiceActionDetails';
import InvoiceMotDetailed from '@pages/Financial/InvoicesMot/InvoiceDetailed';
import Requests from '@pages/Financial/Requests';
import DetailedRequest from '@pages/Financial/Requests/DetailedRequest';
import ConsumerTrafficByCustomerDashboard from '@pages/Insights/ConsumerTrafficByCustomerDashboard';
import Dashboard from '@pages/Insights/Dashboard';
import RoamingReport from '@pages/Insights/Roaming';
import { SimcardsOnlineProducts } from '@pages/Insights/SimcardsOnlineProducts';
import TransactionsDashboard from '@pages/Insights/TransactionDashboard';
import MainDashboard from '@pages/MainDashboard';
import Applications from '@pages/Operational/Applications';
import AutoServices from '@pages/Operational/AutoServices';
import DeviceQuery from '@pages/Operational/DeviceQuery';
import Operations from '@pages/Operational/Operations';
import Transfers from '@pages/Operational/Transfers';
import SmsConfig from '@pages/Sms/SmsConfig';
import SmsRequest from '@pages/Sms/SmsRequests';
import SmsSenders from '@pages/Sms/SmsSenders';
import SmsTemplates from '@pages/Sms/SmsTemplates';
import Banners from '@pages/Support/Banners';
import ServiceRequests from '@pages/Support/ServiceRequests';
import { AiOutlineFileSearch } from 'react-icons/ai';
import { BsGear } from 'react-icons/bs';
import { FiExternalLink } from 'react-icons/fi';
import { HiOutlineDeviceTablet } from 'react-icons/hi';
import { IoTicketOutline } from 'react-icons/io5';
import Consumption from '@pages/Insights/Consumption';
import { MdOutlineSendToMobile } from 'react-icons/md';
import { RiRoadMapLine } from 'react-icons/ri';
import { VscBook } from 'react-icons/vsc';
import SharedPlans from '@pages/Administrative/SharedPlans';
import SharedPlanDetails from '@pages/Administrative/SharedPlans/SharedPlanDetails';
import BusinessGroupingDetails from '@pages/Administrative/Groupings/GroupingDetails';
import ProtectedRoute from '@components/ProtectedRoute';
import AlarmHistory from '@pages/Insights/Alerts/AlarmHistory/AlarmHistory';
import AlarmNotification from '@pages/Insights/Alerts/AlarmNotification/AlarmNotification';
import AlertList from '@pages/Insights/Alerts/AlertList';
import BillingDashboard from '@pages/Insights/BillingDashboard';
import APIDashboards from '@pages/API/Dashboards';
import {
  ApplicationsConstants,
  motProducts,
} from '@utils/applicationsConstants';

export const portalRoutes = {
  assets: [
    {
      name: 'management',
      path: 'inventory',
      role: roles.MANAGEMENT,
      icon: <DatabaseOutlined />,
      element: <Inventory />,
      application: [
        ApplicationsConstants.MULTI_CONNECT,
        ApplicationsConstants.CONNECT_ONE,
        ...motProducts,
      ],
    },
    {
      path: 'devices',
      role: roles.DEVICES,
      icon: <HiOutlineDeviceTablet />,
      element: <ConnectedDevices />,
      application: [ApplicationsConstants.MOT_PAY],
    },
    {
      path: 'sessions',
      icon: <HistoryOutlined />,
      role: roles.VIEW_AUTHENTICATIONS,
      element: <Sessions />,
      application: [
        ApplicationsConstants.CONNECT_ONE,
        ApplicationsConstants.MULTI_CONNECT,
        ...motProducts,
      ],
      rootCannotSee: true,
    },
    {
      path: 'transactions',
      role: roles.VIEW_TPDU,
      icon: <CreditCardOutlined />,
      element: <Transactions />,
      application: [
        ApplicationsConstants.CONNECT_ONE,
        ApplicationsConstants.MULTI_CONNECT,
      ],
      rootCannotSee: true,
    },
    {
      path: 'coverage-map',
      role: roles.VIEW_COVERAGE_MAP,
      icon: <RiRoadMapLine />,
      element: <Maps />,
      application: [
        ApplicationsConstants.CONNECT_ONE,
        ApplicationsConstants.MULTI_CONNECT,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
        ApplicationsConstants.MOT_ESSENTIAL,
      ],
    },
    {
      path: 'transactions-acquiring',
      role: roles.VIEW_TPDU_ACQUIRING,
      icon: <SwapOutlined />,
      element: <TransactionsAcquiring />,
      application: [ApplicationsConstants.MOT_PAY],
    },
    {
      path: 'online-devices',
      role: roles.INSIGHTS_ONLINE_DEVICES_VIEW,
      icon: <LaptopOutlined />,
      element: <SimcardsOnlineProducts />,
      application: [ApplicationsConstants.INDICATORS],
    },
    {
      path: 'base-evolution',
      role: roles.INSIGHTS_BASE_EVOLUTION_VIEW,
      icon: <DashboardOutlined />,
      element: (
        <ProtectedRoute
          requiredApps={[
            ApplicationsConstants.MULTI_CONNECT,
            ApplicationsConstants.CONNECT_ONE,
          ]}
          requireAll={false}
        >
          <MainDashboard />
        </ProtectedRoute>
      ),
      application: [ApplicationsConstants.INDICATORS],
      requiredApps: [
        ApplicationsConstants.MULTI_CONNECT,
        ApplicationsConstants.CONNECT_ONE,
      ],
      requireAll: false,
    },
    {
      path: 'dashboards',
      role: roles.VIEW_API_DASHBOARDS,
      element: <APIDashboards />,
      application: [ApplicationsConstants.API],
      icon: <DashboardOutlined />,
      hideWhenRoot: true,
    },
  ],
  alarms: [
    {
      path: 'page-alarms',
      role: roles.INSIGHTS_ALARM_CONFIGURATION,
      icon: <SettingOutlined />,
      element: <AlertList />,
      application: [ApplicationsConstants.INDICATORS],
    },
    {
      name: 'page-alarms-history',
      path: 'page-alarms-history',
      role: roles.INSIGHTS_ALARM_HISTORY,
      icon: <HistoryOutlined />,
      element: <AlarmHistory />,
      application: [ApplicationsConstants.INDICATORS],
    },
    {
      name: 'page-alarms-notification',
      path: 'page-alarms-notification',
      role: roles.INSIGHTS_ALARM_NOTIFICATION,
      icon: <BellOutlined />,
      element: <AlarmNotification />,
      application: [ApplicationsConstants.INDICATORS],
    },
  ],
  operational: [
    {
      path: 'actions-queue',
      role: roles.ACTIONS_QUEUE,
      icon: <NodeExpandOutlined />,
      element: <ActionsQueue />,
      application: [
        ApplicationsConstants.CONNECT_ONE,
        ApplicationsConstants.MULTI_CONNECT,
        ...motProducts,
      ],
    },
    {
      path: 'applications',
      role: roles.APPLICATIONS,
      icon: <MergeCellsOutlined />,
      element: <Applications />,
      application: [ApplicationsConstants.MOT_PAY],
    },
    {
      path: 'autoservices',
      role: roles.VIEW_AUTOSERVICES,
      icon: <BsGear />,
      element: <AutoServices />,
      application: [
        ApplicationsConstants.CONNECT_ONE,
        ApplicationsConstants.MULTI_CONNECT,
      ],
    },
    {
      path: 'device-query',
      role: roles.CALL_CENTER,
      icon: <AiOutlineFileSearch />,
      element: <DeviceQuery />,
      application: [
        ApplicationsConstants.CONNECT_ONE,
        ApplicationsConstants.MULTI_CONNECT,
      ],
    },
    {
      path: 'transfers',
      role: roles.VIEW_TRANSFERS,
      icon: <SwapOutlined />,
      element: <Transfers />,
      application: [
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      rootCannotSee: true,
    },
    {
      path: 'operations',
      role: roles.VIEW_OPERATIONS,
      icon: <SettingOutlined />,
      element: <Operations />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
    },
  ],
  insights: [
    {
      path: 'dashboard',
      role: roles.DASHBOARD,
      icon: <PieChartOutlined />,
      element: <Dashboard />,
      application: [
        ApplicationsConstants.MULTI_CONNECT,
        ApplicationsConstants.CONNECT_ONE,
        ...motProducts,
      ],
    },
    {
      path: 'roaming',
      role: roles.VIEW_ROAMING,
      icon: <BarChartOutlined />,
      element: <RoamingReport />,
      application: [ApplicationsConstants.MULTI_CONNECT],
      onlyChildOfRoot: true,
    },
    {
      path: 'consumption',
      role: roles.VIEW_CONSUME,
      icon: <LineChartOutlined />,
      element: <Consumption />,
      application: [
        ApplicationsConstants.MULTI_CONNECT,
        ApplicationsConstants.CONNECT_ONE,
        ...motProducts,
      ],
    },
    {
      path: 'transactions-dashboard',
      role: roles.INSIGHTS_TRANSACTIONS_VIEW,
      icon: <CarryOutOutlined />,
      element: <TransactionsDashboard />,
      application: [ApplicationsConstants.MOT_PAY],
    },
  ],
  alerts: [
    {
      path: 'alerts',
      role: roles.VIEW_ALERTS,
      icon: <AlertOutlined />,
      element: <Alerts />,
      application: motProducts,
      rootCannotSee: true,
    },
    {
      path: 'events',
      role: roles.VIEW_ALERTS,
      icon: <WarningOutlined />,
      element: <AlertsEvents />,
      application: motProducts,
      rootCannotSee: true,
    },
  ],
  financial: [
    {
      path: 'contracts',
      role: roles.VIEW_CONTRACTS,
      icon: <ContainerOutlined />,
      element: <CustomersContracts />,
      application: [ApplicationsConstants.FINANCIAL],
    },
    {
      isDetails: true,
      path: 'contracts/:assetNumber',
      role: roles.VIEW_CONTRACTS,
      icon: <ContainerOutlined />,
      element: <DetailedContractCustomer />,
      application: [ApplicationsConstants.FINANCIAL],
    },
    {
      path: 'invoices',
      role: roles.VIEW_INVOICES,
      icon: <AuditOutlined />,
      element: <Invoices />,
      application: [ApplicationsConstants.FINANCIAL],
      rootCannotSee: true,
    },
    {
      isDetails: true,
      path: 'invoices/:status/:invoiceId',
      role: roles.VIEW_INVOICES,
      element: <InvoicesMultiConnectDetailed />,
      application: [ApplicationsConstants.FINANCIAL],
      rootCannotSee: true,
    },

    {
      path: 'invoices',
      role: roles.VIEW_INVOICES_MOT,
      icon: <AuditOutlined />,
      element: <InvoicesMot />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
      isCommon: true,
    },
    {
      isDetails: true,
      path: 'invoices/:invoiceId/:customerId',
      role: roles.VIEW_INVOICES_MOT,
      element: <InvoiceMotDetailed />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
      isCommon: true,
    },
    {
      isDetails: true,
      path: 'invoices/actions',
      role: roles.VIEW_INVOICE_ACTIONS,
      element: <InvoiceActions />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
      isCommon: true,
    },
    {
      isDetails: true,
      path: 'invoices/actions/details',
      role: roles.VIEW_INVOICE_ACTIONS,
      element: <InvoiceActionDetails />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
      isCommon: true,
    },
    {
      path: 'contracts',
      role: roles.VIEW_CONTRACTS_MOT,
      icon: <ContainerOutlined />,
      element: <ContractsMoT />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
    },
    {
      isDetails: true,
      path: 'contracts/:contractId',
      element: <DetailedContract />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
    },
    {
      path: 'requests',
      role: roles.VIEW_REQUESTS_MOT,
      icon: <FileDoneOutlined />,
      element: <Requests />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
    },
    {
      isDetails: true,
      path: 'requests/:requestId',
      element: <DetailedRequest />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
    },
    {
      path: 'consumer-traffic-by-customer',
      role: roles.FINANCIAL_CONSUMER_TRAFFIC_VIEW,
      icon: <WifiOutlined />,
      element: <ConsumerTrafficByCustomerDashboard />,
      application: [ApplicationsConstants.FINANCIAL],
    },
    {
      path: 'monthly-billing',
      role: roles.FINANCIAL_BILLING_VIEW,
      icon: <DollarOutlined />,
      element: <BillingDashboard />,
      application: [ApplicationsConstants.FINANCIAL],
    },
  ],
  sms: [
    {
      path: 'configuration',
      role: roles.VIEW_SMS,
      icon: <SettingOutlined />,
      element: <SmsConfig />,
      application: [ApplicationsConstants.SMS],
    },
    {
      path: 'request',
      role: roles.VIEW_SMS,
      icon: <MdOutlineSendToMobile />,
      element: <SmsRequest />,
      application: [ApplicationsConstants.SMS],
    },
    {
      path: 'templates',
      role: roles.VIEW_SMS,
      icon: <DatabaseOutlined />,
      element: <SmsTemplates />,
      application: [ApplicationsConstants.SMS],
    },
    {
      path: 'senders',
      role: roles.VIEW_SENDERS,
      icon: <TeamOutlined />,
      element: <SmsSenders />,
      application: [ApplicationsConstants.SMS],
    },
  ],
  access: [
    {
      path: 'customers',
      role: roles.VIEW_CUSTOMERS,
      icon: <TeamOutlined />,
      element: <Customers />,
      application: [ApplicationsConstants.ACCESS],
    },
    {
      path: 'my-user',
      icon: <UserOutlined />,
      element: <MyUser />,
      application: [ApplicationsConstants.ACCESS],
    },
    {
      path: 'users',
      role: roles.VIEW_USERS,
      icon: <UsergroupAddOutlined />,
      element: <UserAccounts />,
      application: [ApplicationsConstants.ACCESS],
    },
    {
      path: 'groups',
      role: roles.VIEW_USERS,
      icon: <UsergroupAddOutlined />,
      element: <UserGroups />,
      application: [ApplicationsConstants.ACCESS],
    },
    {
      path: 'apns',
      role: roles.VIEW_APN,
      icon: <ApartmentOutlined />,
      element: <APNs />,
      application: [ApplicationsConstants.ACCESS],
    },
  ],
  support: [
    {
      path: 'service-requests',
      role: roles.VIEW_SERVICE_REQUESTS,
      icon: <IoTicketOutline />,
      element: <ServiceRequests />,
      application: [ApplicationsConstants.SUPPORT],
      onlyChildOfRoot: true,
    },
    {
      path: 'reports',
      role: roles.VIEW_REPORTS,
      icon: <SnippetsOutlined />,
      element: <Reports />,
      application: [ApplicationsConstants.SUPPORT],
    },
    {
      path: 'banners',
      role: roles.MANAGE_BANNERS,
      icon: <FileImageOutlined />,
      element: <Banners />,
      application: [ApplicationsConstants.SUPPORT],
      onlyChildOfRoot: true,
    },
    {
      name: 'user-manual',
      path: 'https://docs.{domain}/getting-started',
      icon: <VscBook style={{ transform: 'scale(1.2)' }} />,
      externalLink: true,
      application: [ApplicationsConstants.SUPPORT],
    },
    {
      name: 'grafana-monitor',
      path: 'https://{domain}/monitor',
      role: roles.VIEW_GRAFANA_MONITOR,
      icon: <FiExternalLink />,
      externalLink: true,
      application: [ApplicationsConstants.SUPPORT],
      onlyChildOfRoot: true,
    },
    {
      name: 'grafana-specialist',
      path: 'https://{domain}/monitoramento',
      role: roles.VIEW_GRAFANA_ESPECIALIST,
      icon: <FiExternalLink />,
      externalLink: true,
      application: [ApplicationsConstants.SUPPORT],
      onlyChildOfRoot: true,
    },
  ],
  administrative: [
    {
      path: 'shared-plans',
      role: roles.VIEW_SHARED_PLANS,
      icon: <ContainerOutlined />,
      element: <SharedPlans />,
      application: [ApplicationsConstants.MOT_BUSINESS],
      rootCannotSee: true,
    },
    {
      isDetails: true,
      path: 'shared-plans/:sharedPlanId',
      element: <SharedPlanDetails />,
      application: [ApplicationsConstants.MOT_BUSINESS],
      rootCannotSee: true,
    },
    {
      path: 'groupings',
      role: roles.VIEW_GROUPINGS,
      icon: <TeamOutlined />,
      element: <Groupings />,
      application: [ApplicationsConstants.MOT_BUSINESS],
      rootCannotSee: true,
    },
    {
      isDetails: true,
      path: 'groupings/:groupingId',
      element: <BusinessGroupingDetails />,
      application: [ApplicationsConstants.MOT_BUSINESS],
      rootCannotSee: true,
    },
    {
      path: 'departments',
      role: roles.VIEW_DEPARTAMENTS,
      icon: <TeamOutlined />,
      element: <Customers isMotBusiness />,
      application: [ApplicationsConstants.MOT_BUSINESS],
      rootCannotSee: true,
      isCommon: true,
    },
    {
      path: 'customers',
      role: roles.VIEW_CUSTOMERS,
      icon: <TeamOutlined />,
      element: <Customers />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      rootCannotSee: true,
      isCommon: true,
    },
    {
      path: 'personalization',
      role: roles.MANAGE_PERSONALIZATION,
      icon: <FormatPainterOutlined />,
      element: <Personalization />,
      application: motProducts,
      rootCannotSee: true,
      isCommon: true,
    },
  ],
};
